import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260107_prop_vertical_datum_anchor",
  description: "Migrate PropInstanceVerticalDatum enum values to PropInstanceVerticalDatumAnchor",
  apply(json: any): any {
    // Mapping from old enum values to new enum values
    const datumMapping: Record<string, string> = {
      LEVEL: "LEVEL_FLOOR_ELEVATION",
      FLOOR_ELEVATION: "ROOM_FLOOR_ELEVATION",
      GRADE: "LEVEL_GRADE",
    };

    if (json.propInstances) {
      for (const prop of Object.values(json.propInstances)) {
        const propInstance = prop as { verticalDatum?: string };
        if (propInstance.verticalDatum) {
          if (datumMapping[propInstance.verticalDatum]) {
            propInstance.verticalDatum = datumMapping[propInstance.verticalDatum];
          }
        }
      }
    }

    return json;
  },
};

export default migration;
